// Import CSS first
import './styles/site.scss';

// Import core JS files
import './js/accordion.js';
import './js/ajaxForms.js';
import './js/animations.js'; // New custom animation system
import './js/headroom.js';
import './js/nav.js';
import './js/stack.js';

// For homepage, we need to load Vue synchronously to avoid errors
// Check if we're on the homepage and load the carousel
if (document.querySelector('.hammesHomepage #intro')) {
  // Import Vue carousel component synchronously for homepage
  import('./js/homeIntro.js').catch(err => {
    console.error('Failed to load homepage carousel:', err);
  });
}

// Conditionally load Glide.js for carousels
if (document.querySelector('.glide')) {
  import('./js/glide.js');
}

// Conditionally load timeline component
if (document.querySelector('#timeline')) {
  import('./js/timeline.js');
}

// Conditionally load photo modal
if (document.querySelector('[data-photo-modal]')) {
  import('./js/photoModal.js');
}

// Native lazy loading is now used instead of lazysizes